import {WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';
const ROOT = 1;

export const getCoordinates = (parameters, flatArray=false) => {
    let length = parameters.length;
    let values = new Float32Array(
        parameters.map(
            x =>
                x.toSeconds ?
                x.toSeconds(true) :
                x.getNumber(true)));
    let depths = new Float32Array(
        parameters.map(
            x => x.depth));
    let mins = new Float32Array(
        parameters.map(x => x.min));
    let maxes = new Float32Array(
        parameters.map(x => x.max));
    let d_mins = new Float32Array(
        parameters.map(
            x =>
                x.depthParameter ?
                x.depthParameter.min : 0));
    let d_maxes = new Float32Array(
        parameters.map(
            x =>
                x.depthParameter ?
                x.depthParameter.max : 1));

    let ptr_values = window.api.create_buffer(length);
    let ptr_depths = window.api.create_buffer(length);
    let ptr_d_mins = window.api.create_buffer(length);
    let ptr_d_maxes = window.api.create_buffer(length);
    let ptr_mins = window.api.create_buffer(length);
    let ptr_maxes = window.api.create_buffer(length);

    window.Module.HEAPF32.set(values, ptr_values >> 2);
    window.Module.HEAPF32.set(depths, ptr_depths >> 2);
    window.Module.HEAPF32.set(d_mins, ptr_d_mins >> 2);
    window.Module.HEAPF32.set(d_maxes, ptr_d_maxes >> 2);
    window.Module.HEAPF32.set(mins, ptr_mins >> 2);
    window.Module.HEAPF32.set(maxes, ptr_maxes >> 2);

    let outX = window.api.create_geometry_buffer(length);
    let outY = window.api.create_geometry_buffer(length);

    window.api.getCoordinates(
        ptr_values,
        ptr_depths,
        ptr_mins,
        ptr_maxes,
        ptr_d_mins,
        ptr_d_maxes,
        WIDTH,
        HEIGHT,
        PADDING,
        ROOT,
        length,
        outX,
        outY);


    const resultsX = new Uint32Array(window.Module.HEAP32.buffer, outX, length);
    const resultsY = new Uint32Array(window.Module.HEAP32.buffer, outY, length);
    
    let coordinates;
    if (flatArray) {
        coordinates = new Float32Array(2*length);
        for (let i=0; i < length; i++) {
            coordinates[2*i] = resultsX[i];
            coordinates[2*i+1] = resultsY[i];
        }
    } else {
        coordinates = [];
        for (let i=0; i < length; i++) {
            coordinates.push({
                x: resultsX[i],
                y: resultsY[i]
            });
        }
    }
    window.api.destroy_buffer(ptr_values);
    window.api.destroy_buffer(ptr_depths);
    window.api.destroy_buffer(ptr_d_mins);
    window.api.destroy_buffer(ptr_d_maxes);
    window.api.destroy_buffer(ptr_mins);
    window.api.destroy_buffer(ptr_maxes);
    window.api.destroy_buffer(outY);
    window.api.destroy_buffer(outX);
    return coordinates;
}
